// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\r\n/* chrome */\ninput::-webkit-outer-spin-button,\r\ninput::-webkit-inner-spin-button {\r\n  -webkit-appearance: none;\n}\r\n/* 火狐浏览器 */\ninput[type=\"number\"]{\r\n  -moz-appearance: textfield;\n}\n.input_bar_select_root {\n.ant-select {\r\n    min-width: 70px;\n}\n.unit {\r\n    white-space: nowrap;\n}\n}\r\n", ""]);
// Exports
module.exports = exports;
